import React, { useState, } from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import moment from "moment";
import {
  Page,
  onMount,
  FormGroup,
  SubmitButton,
} from "components/common";
import { ReportContainerTrialB } from "./components";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";
import { Trans } from "react-i18next";


export const TrialBalanceWithMovementView = ({ data, item, handleSubmit, setState, client, t, dispatch }) => {

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      dispatch(actions.change("local.file", file));
    }
  };

  return (
    <Page>
      <div className="disc">
        <h4><Trans>Trail Balance with movement (Using General Ledger Summary report)</Trans></h4>
        <p className="text-muted"><Trans>This report is based on <strong><a target="_blank" href="https://reporting.xero.com/Reports/v1/Run/1070" className="link btn-link">General Ledger Summary report</a></strong> export from Xero, it can be used with organisation that have large amounts of data</Trans></p>
      </div>
      <LocalForm
        className="d-print-none"
        getDispatch={(dispatch) => setState({ dispatch })}
        onSubmit={handleSubmit}
        initialState={item}
        validators={{
          // to_date: { required },
        }}
      >
        <div className="d-flex align-items-center">
          <FormGroup label="Upload General Ledger Summary (Excel)" className="mr-3">
            <div className="custom-file">
              <input name="file" type="file" className="custom-file-input" onChange={handleFileChange} required />
              <label className="custom-file-label" htmlFor="customFileInput" style={{ overflow: "hidden" }}>{selectedFile?.name || t("Select File")}</label>
            </div>
          </FormGroup>
          <FormGroup label="&nbsp;">
            <SubmitButton size="sm" className="d-block">
              Update
            </SubmitButton>
          </FormGroup>

        </div>
      </LocalForm>
      {data && <ReportContainerTrialB report={data} />}
    </Page>
  )
};

const loadReport = (item, client, id) =>
  client
    .post(`xero_actions/${id}/trial_balance_with_movement_summary`, item)
    .get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    to_date: moment().format("YYYY-MM-DD"),
    from_date: moment().startOf('month').format("YYYY-MM-DD"),
    payments_only: false
  })),
  onMount(({ client, item, selectedOrganisation }) => () => {
    const { id } = selectedOrganisation;

    item.payments_only = ['true', true, '1', 1].includes(item.payments_only) || false;

    return Promise.props({
      data: null,
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, client, dispatch, setReportParams, selectedOrganisation }) =>
        (item) => {
          let formData = new FormData();
          formData.append('file', item.file);

          return loadReport(formData, client, selectedOrganisation.id)
            .then((data) => setState({ data }))
            .finally(() => {
              dispatch(actions.setSubmitted("local", true))
            });
        },
  })
);

export const TrialBalanceWithMovementBySummary = enhance(TrialBalanceWithMovementView)
